export function BrandLabel({ className = "" }: { className?: string }) {
  return (
    <span className={className}>
      smrtly<span className="text-primary">Fit</span>
    </span>
  );
}
